import { CompRef, Connection } from '@wix/document-services-types';
import { EditorPointer } from '@wix/editorx-core-api';

import { PlatformContext, CustomManifestAction } from '../types';
import { getDataBindingOverrideConfig } from './getDataBindingOverrideConfig';
import { hasDataBindingControllerInContext } from './hasDataBindingControllerInContext';

export type DataBindingOverrideQuery = {
  componentType: string;
  role?: string;
};

function addActionsForComponentType(
  dataBindingOverrideQuery: DataBindingOverrideQuery,
  allActions: Record<string, CustomManifestAction>,
): Record<string, CustomManifestAction> {
  const dataBindingConfig = getDataBindingOverrideConfig(
    dataBindingOverrideQuery,
  );

  if (!dataBindingConfig?.actions) {
    return allActions;
  }

  return {
    ...allActions,
    ...dataBindingConfig.actions,
  };
}

export function getDataBindingOverrideActions(
  platformContext: PlatformContext,
  editorPointer: EditorPointer<CompRef>,
): Record<string, CustomManifestAction> | null {
  const { documentServicesAPI, editorPointerAPI } = platformContext;
  const compRef = editorPointerAPI.getDocumentPointer(editorPointer);

  const connections =
    documentServicesAPI.platform.controllers.connections.get(compRef);

  const dataBindingConnection = connections.find((connection) => {
    try {
      return JSON.parse(connection.config).type === 'dataBinding';
    } catch (e) {
      return false;
    }
  });

  const componentType = documentServicesAPI.components.getType(compRef);

  if (!componentType) {
    return null;
  }

  let dataBindingOverrideActions: Record<string, CustomManifestAction> = {};

  if (dataBindingConnection) {
    const role = dataBindingConnection.role;
    dataBindingOverrideActions = addActionsForComponentType(
      { componentType, role },
      dataBindingOverrideActions,
    );
  } else if (
    hasDataBindingControllerInContext(platformContext, editorPointer)
  ) {
    dataBindingOverrideActions = addActionsForComponentType(
      { componentType },
      dataBindingOverrideActions,
    );
  }

  return Object.keys(dataBindingOverrideActions).length > 0
    ? dataBindingOverrideActions
    : null;
}
